/**
 * @file quotes/index.ts
 * @description Function library for the quotes.
 *
 * @author smendonca
 *
 */

/**
 * Imports.
 */
import { QuotesRequest, GetQuotesResponse } from './quotes.model';
import * as api from '../index';
import { isEmpty } from 'lodash';

/**
 * Gets the product configuration for the site.
 * @param data Dto request object.
 * @param type The rates type to fetch ppm/vsc.
 * @param programId Program identifier.
 * @returns Quotes for the given parameters.
 */
export const getQuotes = async (
  data: QuotesRequest,
  type = '',
  programId = ''
): Promise<GetQuotesResponse> => {
  const { submit } = api;
  let route = 'quotes';
  if (!isEmpty(type)) route += `/${type}`;
  if (!isEmpty(programId)) route += `/${programId}`;
  const result = await submit<QuotesRequest, GetQuotesResponse>(route, data);
  return result;
};
